import {platform} from "@/api/platform";
import {retryRequest} from "@/helpers/request";

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getCatalogMessages() {

            const userId = this.getters["user/id"];

            return retryRequest(() => platform.get(`/api/v2/user/${userId}/catalog-message`))
                .then(response => {

                    const results = response.data.results;

                    // Check for we still have legacy format (single message)
                    if (results.message) {

                        return [{message: results.message, email: results.email ?? null}];
                    }

                    if (Array.isArray(results) && 0 < results.length) {

                        return results.map(
                            (item) => "string" === typeof item
                                ? {message: item, email: null}
                                : {message: item.message, email: item.email}
                        );
                    }

                    return [];
                });
        }
    }
}